<template>
<div class="securityService">
  <div class="title" v-if="insuranceList.length !== 0">保险</div>
  <div class="insuranceBox"  v-for="(item, index) in insuranceList" :key="index" @click="detail(item.id, '保险')">
    <div>
      <img class="headImg" src="../../assets/images/distribution/paihuo_touxiang_default.png"
           v-if="!item.img">
      <img :src="item.img" v-else class="headImg" @click.stop="imagePreview(item.img)">
    </div>
    <div class="personInformation">
      <div class="name van-ellipsis">{{ item.title }}</div>
      <div class="introduce van-multi-ellipsis--l2">{{ item.introduce }}</div>
    </div>
  </div>
  <div class="title" v-if="physicaExaminationList.length !== 0">体检</div>
  <div class="insuranceBox"  v-for="(item, index) in physicaExaminationList" :key="index" @click="detail(item.id, '体检')">
    <div>
      <img class="headImg" src="../../assets/images/distribution/paihuo_touxiang_default.png"
           v-if="!item.img">
      <img :src="item.img" v-else class="headImg" @click.stop="imagePreview(item.img)">
    </div>
    <div class="personInformation">
      <div class="name van-ellipsis">{{ item.title }}</div>
      <div class="introduce van-multi-ellipsis--l2">{{ item.introduce }}</div>
    </div>
  </div>
  <div class="title" v-if="makeInvoiceList.length !== 0">开票</div>
  <div class="insuranceBox"  v-for="(item, index) in makeInvoiceList" :key="index" @click="detail(item.id, '开票')">
    <div>
      <img class="headImg" src="../../assets/images/distribution/paihuo_touxiang_default.png"
           v-if="!item.img">
      <img :src="item.img" v-else class="headImg" @click.stop="imagePreview(item.img)">
    </div>
    <div class="personInformation">
      <div class="name van-ellipsis">{{ item.title }}</div>
      <div class="introduce van-multi-ellipsis--l2">{{ item.introduce }}</div>
    </div>
  </div>
  <div v-if="insuranceList.length === 0 && physicaExaminationList.length === 0 && makeInvoiceList.length === 0 " class="noContent">
    <img src="../../assets/images/blank_icon_project.png">
    <div class="blank-tip">暂无内容</div>
  </div>
  <imagePopup v-model="showImagePopup" :imgUrl="imgUrl"/>
</div>
</template>

<script>
import { contentList } from '@api/home'
import imagePopup from '@components/imagePopup/imagePopup'
export default {
  name: "index",
  components: {
    imagePopup
  },
  data () {
    return {
      showImagePopup: false,
      imgUrl: '',
      insuranceList: [], // 保险
      physicaExaminationList: [], // 体检
      makeInvoiceList: [] // 开票
    }
  },
  mounted () {
    this.contentList()
  },
  methods: {
    contentList () {
      contentList({
        moduleId: 1
      }).then(res => {
        if (res.data.code === 200) {
          // 把安全小知识和培训合并在一起
          this.insuranceList = res.data.data[0].infos
          this.physicaExaminationList = res.data.data[1].infos
          this.makeInvoiceList = res.data.data[2].infos
        } else {
          this.$toastMsg(res.data.msg)
        }
      })
    },
    detail (id, type) {
      // this.enterRouter('trainingDetail', { id: id })
      const data = {
        url: `${process.env.VUE_APP_BASE_HOST}/trainingDetail?id=${id}`,
        title: type
      }
      this.$bridge.callHandler('newPage', data, response => {
        console.log('response:', response)
      })
    },
    imagePreview (imgUrl) {
      this.showImagePopup = true
      this.imgUrl = imgUrl
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/css/mixin";
.securityService{
  padding-bottom: 30px;
  .title{
    @include add_size($font_size_20);
    margin: 12px 15px;
    font-weight: bold;
    color: #333333;
  }
  .insuranceBox{
    display: flex;
    background-color: #fff;
    padding: 12px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.02);
    opacity: 1;
    border-radius: 5px;
    margin: 15px;
    .headImg{
      width: 100px;
      height: 100px;
      border-radius: 5px;
      flex-shrink: 0;
    }
    .personInformation{
      width: calc(100% - 120px);
      margin-left: 10px;
      color: #333333;
      .name{
        font-weight: bold;
        @include add_size($font_size_24);
        margin-bottom: 8px;
      }
      .introduce{
        @include add_size($font_size_20);
      }
    }
  }
}
</style>
